// extracted by mini-css-extract-plugin
export default {"line":"DetailsModal_line__0DGME","link":"DetailsModal_link__1haj6"};